import * as React from "../../_snowpack/pkg/react.js";
import {contentLabels} from "../assets/surveyFormat.js";
import DetailListItem from "./DetailListItem.js";
const DisplaySurveyResponse = ({
  survey
}) => {
  const contentsInOrder = [
    (survey.tenure_total_num || "").toString(),
    (survey.tenure_women_num || "").toString(),
    survey.tenure_total_num && survey.tenure_women_num ? `${(survey.tenure_total_num === 0 ? 0 : survey.tenure_women_num / survey.tenure_total_num * 100).toFixed(0)}%` : "",
    (survey.grad_total_num || "").toString(),
    (survey.grad_women_num || "").toString(),
    survey.grad_total_num && survey.grad_women_num ? `${(survey.grad_total_num === 0 ? 0 : survey.grad_women_num / survey.grad_total_num * 100).toFixed(0)}%` : "",
    (survey.postdoc_total_num || "").toString(),
    (survey.postdoc_women_num || "").toString(),
    survey.postdoc_total_num && survey.postdoc_women_num ? `${(survey.postdoc_total_num === 0 ? 0 : survey.postdoc_women_num / survey.postdoc_total_num * 100).toFixed(0)}%` : "",
    survey.q3_policy,
    survey.q4_insurance,
    survey.women_group || "",
    survey.physics_gsa || "",
    survey.other_stugrp || "",
    survey.undergra_womconf || "",
    `${[survey.q6_sitevisit, survey.site_visit].map((s) => s?.length).reduce((acc, el) => acc ? el ? acc > el ? acc : el : acc : el) === survey.q6_sitevisit.length ? survey.q6_sitevisit : survey.site_visit}`,
    survey.q5_friendly,
    survey.contact_info || ""
  ];
  return /* @__PURE__ */ React.createElement("article", {
    className: "w-full mx-auto pb-10"
  }, /* @__PURE__ */ React.createElement("h2", {
    className: "text-blue-700 text-2xl p-4 text-center"
  }, survey.institution, survey.department.length ? `(${survey.department})` : ""), /* @__PURE__ */ React.createElement("p", {
    className: "italic mb-4 text-sm"
  }, "(Last updated", " ", new Date(Date.parse(survey.updated_on)).toLocaleDateString(), ")"), /* @__PURE__ */ React.createElement("ul", {
    className: ""
  }, contentLabels.length === contentsInOrder.length && contentLabels.map((label, idx) => /* @__PURE__ */ React.createElement(DetailListItem, {
    key: `detail/${idx}`,
    label,
    content: contentsInOrder[idx]
  }))));
};
export default DisplaySurveyResponse;
